module.exports = __webpack_public_path__ + "static/media/banner-child.2b814362.png";